import {ofType} from "redux-observable";
import * as individuiActions from '../../actions/actionsTypes/individuoActionType';
import * as corso_corsiActions from '../../actions/actionsTypes/corso_corsiActionsType';
import * as notifActions from '../../actions/actions/notifsActions';
import {catchError, map, retry, switchMap, withLatestFrom} from "rxjs/operators";
import new_axios_istance from "../../axios_instance";
import new_axios_instance from "../../axios_instance";
import {asyncScheduler, forkJoin, from, iif, of, scheduled, throwError, zip} from "rxjs";

import {TIPO_CORSO} from "../../costanti";

import {corsoCorsiActions} from '../../slices/corso_corsiSlice';

import {getAttivitaByTipoCorsoSuccess} from "../../actions/actions/tipiAttivitaActions";
import {getTipoGiustificativiByTipoCorsoSuccess} from "../../actions/actions/giustificativiAction";
import {getDocentiByObjectIdSuccess, getIndividuiByObjectIdSuccess} from "../../actions/actions/individuoAction";
import {hideLoadingOverlay, showLoadingOverlay} from "../../actions/actions/loadingOverlayActions";


export const loadDataOfCourse = (actions$, state$) =>
    actions$.pipe(
        ofType(corso_corsiActions.GET_LOAD_DATA_OF_COURSE),
        withLatestFrom(state$),
        switchMap(([, state]) => {
            const corso = state.corso.corso;
            return iif(() => corso.tipoCorso === TIPO_CORSO.FORMAZIONE || TIPO_CORSO.GARANZIA_GIOVANI || TIPO_CORSO.COFO,
                of({
                    type: corso_corsiActions.GET_INIT_DATA,
                    individui: corso.allievi,
                    docenti: corso.docenti,
                    tipoCorso: corso.tipoCorso

                }, showLoadingOverlay()),
                of({
                    type: corso_corsiActions.GET_INIT_DATA,
                    individui: corso.allievi,
                    tipoCorso: corso.tipoCorso
                }, showLoadingOverlay()))

        }),
        retry(2)
    );

export const loadDataTraining = (actions$) =>
    actions$.pipe(
        ofType(
            corso_corsiActions.GET_INIT_DATA,
            individuiActions.GET_INDIVIDUI
        ),
        switchMap(({type, tipoCorso = '', individui = [], docenti = []}) => {
            sessionStorage.removeItem('validationCache')
            sessionStorage.removeItem('page')
            sessionStorage.removeItem('cognome')
            const forkJoins = [];

            if (individui.length > 0) {
                const individuiReq = Promise.resolve(individui);
                forkJoins.push(individuiReq);
            } else {
                // segna posto per destructuring
                forkJoins.push(of([]));
            }

            if (type === corso_corsiActions.GET_INIT_DATA) {

                const attivita = from(new_axios_instance(`/v1/tipoattivita/ricerca/tipoCorso/${tipoCorso}`))
                    .pipe(
                        map(res => res.data),
                        catchError(_ => of({error: 'Errore durante recupero attività'}))
                    );

                const giustificativi = from(new_axios_instance.get(`/v1/tipogiustificativo/ricerca/tipoCorso/${tipoCorso}`))
                    .pipe(
                        map(res => res.data),
                        catchError(_ => of({error: 'Errore durante recupero giustificativi'}))
                    );

                forkJoins.push(forkJoin([attivita, giustificativi]));

                if (tipoCorso === TIPO_CORSO.FORMAZIONE || TIPO_CORSO.GARANZIA_GIOVANI || TIPO_CORSO.COFO) {

                    if (docenti.length > 0) {
                        const docentiReq = Promise.resolve(docenti)
                        forkJoins.push(docentiReq);
                    } else {
                        // segna posto per destructuring
                        forkJoins.push(of([]));
                    }
                }
            } else {
                // segna posto per destructuring
                forkJoins.push(of([[], []], of([])));
            }

            return zip(...forkJoins);

        }),
        switchMap(([individui = [], attivita_giust = [], docenti = []]) => {
            const notifsError = [];
            if (!Array.isArray(attivita_giust[0]) && attivita_giust[0].hasOwnProperty('error')) {
                notifsError.push(notifActions.notifError(attivita_giust[0].error));
            }
            if (!Array.isArray(attivita_giust[1]) && attivita_giust[1].hasOwnProperty('error')) {
                notifsError.push(notifActions.notifError(attivita_giust[1].error));
            }
            if (individui.some(i => i.hasOwnProperty('error'))) {
                notifsError.push(notifActions.notifError(individui.find(i => i.hasOwnProperty('error')).error));
            }
            if (docenti.some(i => i.hasOwnProperty('error'))) {
                notifsError.push(notifActions.notifError(docenti.find(i => i.hasOwnProperty('error')).error));
            }
            return iif(() => notifsError.length > 0,
                throwError(() => notifsError),
                of(
                    getAttivitaByTipoCorsoSuccess(attivita_giust[0]),
                    getTipoGiustificativiByTipoCorsoSuccess(attivita_giust[1]),
                    getIndividuiByObjectIdSuccess(individui),
                    getDocentiByObjectIdSuccess(docenti),
                    hideLoadingOverlay()
                )
            )

        })
    );

